import DeauvilleSeptember2024 from "../../components/before-after/DeauvilleSeptember2024";

const DeauvilleSeptember2024View = () => {

    return (
        <div className="before-after-deauville-september-2024">
            <DeauvilleSeptember2024/>
        </div>
    );
};

export default DeauvilleSeptember2024View;